import { SsaoShader } from "./SsaoShader";

/**
 * [SsaoShader] with two samples per fragment instead of six, for devices which cannot afford
 * the full one. Everything else of the shader, including the sampling spiral, is the same -
 * the offsets are derived from the sample count, so they follow it.
 */
export class SsaoFastShader extends SsaoShader {
    /** @inheritdoc */
    protected override get samples(): number {
        return 2;
    }
}
